import { Component, OnInit } from '@angular/core';
import { CadastroService } from 'src/app/services/cadastro.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AdesaoService } from 'src/app/services/adesao.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-termos',
    templateUrl: './termos.component.html',
    styleUrls: ['./termos.component.css'],
    imports: [ReactiveFormsModule]
})
export class TermosComponent implements OnInit {

  dados: any = null;

  loadingUSPerson: boolean = false;
  loadingPPE: boolean = false;

  nifs: any = [];
  nacionalidades:any[] = [];

  nifForm: FormGroup = null;
  termosUSPersonForm: FormGroup = null;
  termosPPEForm: FormGroup = null;

  assinatura: string = "";


  constructor(private cadastro: CadastroService, private adesao: AdesaoService, private toastr: ToastrService) {

    this.termosUSPersonForm = new FormGroup({
      decUSPerson: new FormControl(null, [Validators.required]),
      assinatura: new FormControl("", [Validators.required])
    });

    this.termosPPEForm = new FormGroup({
      decPPE: new FormControl(null, [Validators.required]),
      assinatura: new FormControl("", [Validators.required])
    });

    this.nifForm = new FormGroup({
      decOutraNacionalidade: new FormControl(null, [Validators.required]),
      numNIF: new FormControl(null, [Validators.required]),
      dcrNacionalidade: new FormControl("", [Validators.required]),
      assinatura: new FormControl("", [Validators.required])
    });

  }

  ngOnInit() {
    this.carregar();
    this.listaNacionalidades();
  }

  setForm(){

    let d = this.dados;

    this.nifForm.get('decOutraNacionalidade').setValue(d.outraNacionalidade);
    this.termosUSPersonForm.get('decUSPerson').setValue(d.usPerson);
    this.termosPPEForm.get('decPPE').setValue(d.ppe);

  }

  carregar(){

    this.cadastro
    .termosCarregar()
    .subscribe(
      (res: any) => {

        this.dados = res;
        this.setForm();

      },
    )

  }


  salvarUSPerson(): boolean {

    let assinatura = this.termosUSPersonForm.get('assinatura').value;

    if(assinatura.length < 8){
      alert('Digite sua assinatura');
      return false;
    }

    this.loadingUSPerson = true;

    this.cadastro.termosUSPersonAlterar(this.termosUSPersonForm.value)
    .pipe(
      finalize(()=>{ this.loadingUSPerson = false })
    )
    .subscribe(
      (res:any)=>{
        this.toastr.success("Alterado com sucesso")

        this.carregar();
      },
      (error: HttpErrorResponse)=>{
        this.toastr.error(error.error.ex);
      }
    )

    return true;
  }

  salvarPPE(): boolean {

    let assinatura = this.termosPPEForm.get('assinatura').value;

    if(assinatura.length < 8){
      alert('Digite sua assinatura');
      return false;
    }

    this.loadingPPE = true;

    this.cadastro.termosPPEAlterar(this.termosPPEForm.value)
    .pipe(
      finalize(()=>{ this.loadingPPE = false })
    )
    .subscribe(
      (res:any)=>{
        this.toastr.success("Alterado com sucesso")

        this.carregar();
      },
      (error: HttpErrorResponse)=>{
        this.toastr.error(error.error.ex);
      }
    )

    return true;
  }

  onChangeOutraNacionalidade(v){

    if(v=='N' && this.dados.nacionalidades.length > 0){

      alert('Você deve excluir todos os itens da lista antes de mudar para a opção "Não"');

      setTimeout(() => {
        this.nifForm.get('decOutraNacionalidade').setValue('S');
      }, 100);

    }

  }

  listaNacionalidades(){
    this.adesao.ListarNacionalidades()
    .subscribe(
      (res:any)=>{
        this.nacionalidades = res;
      }
    )
  }

  incluirNIF(): boolean{

    let assinatura = this.nifForm.get('assinatura').value;

    if(assinatura.length < 8){
      alert('Digite sua assinatura');
      return false;
    }

    this.cadastro.termosSalvarNIF(this.nifForm.value)
    .pipe(
      finalize(()=>{})
    )
    .subscribe(
      (res:any)=>{
        this.toastr.success("Item incluído com sucesso")

        this.carregar();
      },
      (error: HttpErrorResponse)=>{
        this.toastr.error(error.error.ex);
      }
    )

    return false;

  }

  removerNIF(dcrNacionalidade): boolean {

    let assinatura = this.nifForm.get('assinatura').value;

    if(assinatura.length < 8){
      alert('Digite sua assinatura eletrônica');
      return false;
    }

    let conf = window.confirm("Deseja realmente remover este item ?");

    if(!conf){
      return false;
    }

    let dados = {dcrNacionalidade: dcrNacionalidade, assinatura: assinatura};

    this.cadastro.termosExcluirNIF(dados)
    .pipe(
      finalize(()=>{})
    )
    .subscribe(
      (res:any)=>{
        this.toastr.success("Item excluído com sucesso")
        this.carregar();
      },
      (error: HttpErrorResponse)=>{
        this.toastr.error(error.error.ex);
      }
    )

    return true;
  }

}
